<template>
  <div class="sc-join">
      <div class="sc-join-header">
        <div class="container">
          <h2 class="sc-title -center -small-margin"> Stále hľadáme šikovných ľudí </h2>
          <p class="sc-lead -center">
            Ak sa nájdeš v nižšie uvedených pozíciách, možno si práve ty chýbajúcim článkom nášho tímu. Ak nie, radi sa
            dozvieme o tvojom talente. Pozri si otvorené ponuky, pošli nám CV alebo nechaj na seba kontakt.
          </p>
        </div>
      </div>
    <div class="container">

      <div class="sc-join-positions row">
        <div
          v-for="position in positions"
          :key="position.name"
          class="column -md4"
        >
          <div class="sc-join-card">
            <div class="sc-join-card-header">
              <h3 class="sc-join-card-title">{{ position.name }}</h3>
              <div class="sc-join-card-iconwrap">
                <img src="@/assets/sc/job-position.svg" :alt="position.name">
              </div>
            </div>
            <p class="sc-join-card-description">
              {{ position.description }}
            </p>
            <a class="sc-join-card-readmore" :href="position.url" target="_blank">
              Viac info
            </a>
          </div>
        </div>
      </div>
      <div class="sc-join-footer">
        <UButton
          size="large"
          variant="white"
          glow
          @click="$emit('cv-open')"
        >
          <template #icon>
            <CVIcon/>
          </template>
          Pošli nám životopis
        </UButton>
        <div class="sc-join-footer-contact">
          alebo <a href="#">nám nechaj svoj kontakt</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UButton from '@/components/UButton.vue';
import CVIcon from '@/assets/inlineicons/cv.svg?inline';

export default {
  components: {
    UButton,
    CVIcon,
  },
  data() {
    return {
      positions: [
        {
          name: 'Sprostredkovateľ finančných služieb',
          description: 'Staň sa súčasťou tímu obchodníkov a pomôž nám zefektívniť starostlivosť o klientov a získavanie nových klientov v tvojom regióne.',
          url: 'https://www.profesia.sk/praca/wustenrot/O3713674',
        },
        {
          name: 'Manažér obchodnej skupiny',
          description: 'Ideálne miesto pre človeka so skúsenosťami v oblasti finančníctva. Táto pozícia ponúka okrem starostlivosti o našich klientov aj možnosť vybudovať silný a stabilný tím obchodníkov, ktorých budete manažovať.',
          url: 'https://www.profesia.sk/praca/wustenrot/C109977',
        },
        {
          name: 'Agentúrny riaditeľ',
          description: 'Ak si vo financiách a manažovaní ľudí ako doma, pomôž nám vybudovať silné a stabilné zázemie pre klientov v pobočke, kde budeš lídrom práve ty.',
          url: 'https://www.profesia.sk/praca/wustenrot/O3765759 ',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.sc-join {
  @media screen and (min-width: $screen-md) {
    position: relative;
    background-image: url('../assets/sc/flag2.jpg');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: auto 670px;
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 170px;
      background-image: url('../assets/sc/white-corner.svg');
      background-size: 100% 100%;
    }
  }
  .sc-join-header {
    margin-bottom: 50px;
    @media screen and (min-width: $screen-md) {
      margin-top: 30px;
      margin-bottom: 180px;
    }
  }
  .sc-join-positions {
    @media screen and (min-width: $screen-md) {
      margin-bottom: 80px;
    }
  }
  .sc-join-card {
    background-color: $primary-dark;
    color: white;
    padding: 25px;
    margin-bottom: 20px;
    @media screen and (min-width: $screen-md) {
      padding: 30px;
    }
    .sc-join-card-header {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
    }
    .sc-join-card-title {
      font-size: 16px;
      padding-right: 10px;
      flex: 1;
      word-break: break-word;
      @media screen and (min-width: $screen-md) {
        font-size: 22px;
      }
    }
    .sc-join-card-description {
      font-size: 14px;
      opacity: 0.7;
      min-height: 95px;
    }
    .sc-join-card-readmore {
      color: white;
      text-decoration: none;
    }
    .sc-join-card-iconwrap {
      width: 64px;
      height: 64px;
      flex: 0 0 64px;
      border-radius: 50%;
      background-color: $primary;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (min-width: $screen-md) {
        width: 80px;
        height: 80px;
        flex: 0 0 80px;
      }

    }
  }
  .sc-join-footer {
    margin-top: 30px;
    text-align: center;
    position: relative;
  }
  .sc-join-footer-contact {
    color: $gray-400;
    text-align: center;
    padding-top: 20px;
    a {
      color: inherit;
      font-weight: 700;
    }
  }
}
</style>
